@if (visible()) {
<av-card class="audio-interruption-panel">
  <av-card-header (close)="dismiss()">
    {{ "Audio paused" | translate }}
  </av-card-header>
  <av-card-body>
    <av-icon name="mic-mute" mode="dark"></av-icon>
    <p>
      <small translate>audio interruption body</small>
    </p>
  </av-card-body>
  <av-card-footer>
    <button
      avButton
      color="accent"
      size="block"
      [disabled]="recovering()"
      (click)="resume()"
      data-tid="audio-interruption-overlay/resume"
    >
      @if (recovering()) {
      <span translate>Resuming...</span>
      } @else {
      <span translate>Resume audio</span>
      }
    </button>
  </av-card-footer>
</av-card>
<!-- <div class="audio-interruption-panel" role="alertdialog">
  
</div> -->
}
